import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class FormActionButtons extends PureComponent {
  render () {
    const { onClickCancel, cancelTitle, submitTitle, isSubmitDisabled, className } = this.props;

    return (
      <div className={`d-flex justify-content-between ${className || ''}`}>
        <button type='button' className='button button-cancel' onClick={onClickCancel}>{cancelTitle}</button>
        <button type='submit' className='button button-primary' disabled={isSubmitDisabled}>{submitTitle}</button>
      </div>
    );
  }
}

FormActionButtons.propTypes = {
  onClickCancel: PropTypes.func.isRequired,
  cancelTitle: PropTypes.string,
  submitTitle: PropTypes.string,
  isSubmitDisabled: PropTypes.bool,
  className: PropTypes.string
};

FormActionButtons.defaultProps = {
  cancelTitle: 'Cancel',
  submitTitle: 'Submit',
  isSubmitDisabled: false
};



// WEBPACK FOOTER //
// ./src/components/common/forms/FormActionButtons/index.js